var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M320 250H30c-16.6 0-30-13.4-30-30V30C0 13.4 13.4 0 30 0h290c16.6 0 30 13.4 30 30v190c0 16.6-13.4 30-30 30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7E7",
    d: "M320 10c11 0 20 9 20 20v190c0 11-9 20-20 20H30c-11 0-20-9-20-20V30c0-11 9-20 20-20h290m0-10H30C13.4 0 0 13.4 0 30v190c0 16.6 13.4 30 30 30h290c16.6 0 30-13.4 30-30V30c0-16.6-13.4-30-30-30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79F1A",
    d: "M275.805 125.015c0 34.514-27.95 62.465-62.344 62.465s-62.343-27.95-62.343-62.465S179.07 62.55 213.46 62.55s62.345 27.95 62.345 62.465z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA001B",
    d: "M198.878 125.015c0 34.514-27.952 62.465-62.344 62.465S74.19 159.53 74.19 125.015s27.95-62.466 62.344-62.466 62.344 27.95 62.344 62.465z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F01",
    d: "M174.937 75.796c-14.584 11.423-23.82 29.167-23.82 49.22s9.358 37.794 23.82 49.218c14.583-11.424 23.82-29.167 23.82-49.22s-9.237-37.795-23.82-49.218z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.d92360c266808f056e1b24f98e3614fb.svg";
export { ForwardRef as ReactComponent };